import { createSlice } from "@reduxjs/toolkit";
import { getDishesDetailsAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getDishesDetailsSlice = createSlice({
  name: "getDishesDetails",
  initialState: data,
  reducers: {
   getDishesDetailsSlice(state) {
      state.isLoading = true;
    },
   getDishesDetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getDishesDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getDishesDetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getDishesDetailsHandler: any = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getCustomersDetailsAction.getDishesDetailsSlice());
    const response: any = await getDishesDetailsAPI(id);
    
    dispatch(getCustomersDetailsAction.getDishesDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCustomersDetailsAction.getDishesDetailsSliceFailure(e?.response?.data));
  }
};
export default getDishesDetailsSlice.reducer;
export const getCustomersDetailsAction = getDishesDetailsSlice.actions;
